import { buildCloudinaryVideoUrl } from './cloudinary';

/**
 * Uploaded clips in Cloudinary (folder: databiqs-assets).
 * Keys match former local filenames (without .mp4).
 */
export const CLOUDINARY_VIDEO_REGISTRY = {
  '4354448-uhd_3840_2160_25fps': {
    version: 'v1779295406',
    publicId: '4354448-uhd_3840_2160_25fps_imnk7m',
  },
  '7687810-uhd_4096_2160_24fps': {
    version: 'v1779295407',
    publicId: '7687810-uhd_4096_2160_24fps_lywssl',
  },
  '8501993-uhd_2160_3840_25fps': {
    version: 'v1779295413',
    publicId: '8501993-uhd_2160_3840_25fps_iodbgy',
  },
  '6153453-uhd_4096_2160_25fps': {
    version: 'v1779295407',
    publicId: '6153453-uhd_4096_2160_25fps_ga2r4k',
  },
  '8467244-uhd_3840_2160_25fps': {
    version: 'v1779295413',
    publicId: '8467244-uhd_3840_2160_25fps_nmac7z',
  },
  '8084751-uhd_3840_2160_25fps': {
    version: 'v1779295410',
    publicId: '8084751-uhd_3840_2160_25fps_gloxzu',
  },
  '8328106-uhd_2160_3840_25fps': {
    version: 'v1779295413',
    publicId: '8328106-uhd_2160_3840_25fps_drdtlu',
  },
  '7688618-uhd_2160_4096_24fps': {
    version: 'v1779295411',
    publicId: '7688618-uhd_2160_4096_24fps_zasgyk',
  },
  '8084494-uhd_3840_2160_25fps': {
    version: 'v1779295410',
    publicId: '8084494-uhd_3840_2160_25fps_ftqpw8',
  },
  '8084620-uhd_3840_2160_25fps': {
    version: 'v1779295408',
    publicId: '8084620-uhd_3840_2160_25fps_iew7a0',
  },
  '8464662-uhd_3840_2160_25fps': {
    version: 'v1779295412',
    publicId: '8464662-uhd_3840_2160_25fps_fuhjcg',
  },
  '8327799-uhd_3840_2160_25fps': {
    version: 'v1779295411',
    publicId: '8327799-uhd_3840_2160_25fps_firdd9',
  },
  '8086703-uhd_3840_2160_25fps': {
    version: 'v1779295410',
    publicId: '8086703-uhd_3840_2160_25fps_ezlhrd',
  },
};

/** @param {keyof typeof CLOUDINARY_VIDEO_REGISTRY} key @param {'card' | 'solution' | 'hero'} [preset] */
export function cloudinaryVideo(key, preset = 'card') {
  const asset = CLOUDINARY_VIDEO_REGISTRY[key];
  if (!asset) {
    throw new Error(`Unknown Cloudinary video key: ${key}`);
  }
  return buildCloudinaryVideoUrl(asset, preset);
}
